import { clearSearchData } from '@/checkout-instore-legacy/cache/utils'
import localForage from 'localforage'

import { persistorKey } from '../../../core/globalState/persist'
import { sendWebViewBridgeEvent } from '../../../utils/webview'

// Yeah having to manipulate the cache manually is horrible
// But is a limitation from the new version of redux-persist right now: https://github.com/rt2zz/redux-persist/issues/935
async function clearPersistorCache(keys: string[] = []) {
  const data = (await localForage.getItem<string>(persistorKey)) ?? '{}'

  const removedData = Object.fromEntries(keys.map((key) => [key, undefined]))

  const newData = { ...JSON.parse(data), ...removedData }

  await localForage.setItem(persistorKey, JSON.stringify(newData))
}

async function clearOrderCache() {
  return clearPersistorCache(['order'])
}

export async function clearAllCache() {
  sendWebViewBridgeEvent({
    type: 'clearAllCache',
  })

  await clearSearchData()

  await clearOrderCache()
}
